import { Avatar, Button, Card, Col, Form, List, Row, Select, Space, Upload, notification } from "antd";
import { CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import InputNormal from "../../../components/InputNormal";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLoading } from "../../../contexts/LoadingContext";
import { createUsuario, getAllUsuarios } from "../../../api/usuarios";
import { getAllPermissoes } from "../../../api/permissoes";

const { Option } = Select;

const formItemLayout = {
    labelCol: { flex: '0 0 25px' }, // Ajuste a largura das labels conforme necessário
    wrapperCol: { flex: '1' },
};

type permissoesType = {
    id: string;
    nomePermissao: string;
}

export default function Usuarios() {
    const { setLoading } = useLoading();
    const [btnLoading, setBtnLoading] = useState(false);
    const [permissoes, setPermissoes] = useState<permissoesType[]>([]);
    const [allUsers, setAllUsers] = useState<any[]>([]); // TODO: Mudar para o tipo correto
    let navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        getAllPermissoes().then((res) => {
            setPermissoes(res.data);
            getAllUsuariosFromBD();
        });
    }, []);

    const getAllUsuariosFromBD = () => {
        setLoading(true);
        getAllUsuarios().then((res) => {
            setAllUsers(res.data);
            setLoading(false);
        })
    };

    const validateMessages = {
        required: '${label} é obrigatório!',
        types: {
            email: '${label} não é um email válido, verifique se você digitou @gmail por exemplo!',
            number: '${label} is not a valid number!',
        },
    };


    const onFinish = async (values: any) => {
        setBtnLoading(true);
        createUsuario(values).then((res) => {
            setBtnLoading(false);
            console.log(res)
            if (res.status === 500) {
                notification.error({ message: 'Erro!', description: res.data.error });
                return;
            } else if (res.status === 200) {
                notification.success({ message: 'Sucesso!', description: 'Usuario cadastrado com sucesso!' });
                getAllUsuariosFromBD();
                // navigate(-1);
            }

        })
    };

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Row gutter={10}>
                <Col span={12}>
                    <Card title="Cadastrar usuario">
                        <Form
                            name="wrap"
                            onFinish={onFinish}
                            labelCol={formItemLayout.labelCol}
                            labelAlign="left"
                            layout="vertical"
                            colon={false}
                            validateMessages={validateMessages}
                        >
                            <Row gutter={16}>
                                <Col span={12} >
                                    <InputNormal label="Nome:" name="nome" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                                </Col>
                                <Col span={12}>
                                    <InputNormal label="Email:" name="email" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <InputNormal label="Usuario:" name="user" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                                </Col>
                                <Col span={12}>
                                    <InputNormal label="Senha:" name="password" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        name="permissoes"
                                        label="Ação:"
                                        rules={[{ required: true, message: 'Por favor, selecione o tipo da ação!', type: 'array' }]}
                                    >
                                        <Select mode="multiple" placeholder="Por favor, selecione o tipo da ação!">
                                            {permissoes.map((permissao) => (
                                                <Option key={permissao.id} value={permissao.id}>
                                                    {permissao.nomePermissao}
                                                </Option>
                                            ))}

                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row style={{ justifyContent: 'flex-end', marginTop: 15 }}>

                                <Space>
                                    <Form.Item>
                                        <Button type="primary" onClick={() => navigate(-1)}>
                                            VOLTAR
                                        </Button>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" loading={btnLoading} icon={<CheckCircleOutlined />}>
                                            CADASTRAR
                                        </Button>
                                    </Form.Item>
                                </Space>

                            </Row>
                        </Form>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Lista de usuários cadastrados no sistema">
                        <List
                            // pagination={{ position, "bottom" }}
                            dataSource={allUsers}
                            renderItem={(item, index) => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={
                                            <UserOutlined />
                                        }
                                        title={<a href="https://ant.design">{item.nome}</a>}
                                        description={`Email: ${item.email} - Permissões: ${item.Permissoes.map((permissao: any) => permissao.tipoPermissao).join(', ')}`}
                                    />
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
            </Row>
        </Space>
    )
}
